module.exports = __webpack_public_path__ + "img/cod-modern-warfare.56e74c3a.png";